import { Box, Container, Stack, Typography, styled } from '@mui/material';
import { useMemo, useState } from 'react';
import { useThrottle } from 'react-use';
import { useLocales } from 'src/locales';
import { DocsTrashHeader } from './DocsTrashHeader';
import { DocsTrashItem } from './DocsTrashItem';
import { useDocsTrashQuery } from './useDocsTrashQuery';

export function DocTrashContent() {
  const [orderBy, setOrderBy] = useState<'asc' | 'desc'>('desc');
  const [searchText, setSearchText] = useState('');

  const { translate } = useLocales();

  const debouncedValue = useThrottle(searchText, 500);

  const queryParams = useMemo(() => {
    return !debouncedValue.length ? { sort: orderBy } : { q: debouncedValue };
  }, [debouncedValue, orderBy]);

  const { trashDocs, isTrashDocsLoading } = useDocsTrashQuery(queryParams);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  const handleOrderSelect = (orderType: 'asc' | 'desc') => {
    setOrderBy(orderType);
  };

  return (
    <CustomContainer disableGutters>
      <DocsTrashHeader
        handleOrderSelect={handleOrderSelect}
        onChangeSearch={handleInputChange}
        searchText={searchText}
        orderBy={orderBy}
      />
      {(!trashDocs?.length || isTrashDocsLoading) && (
        <Box
          sx={{
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="caption" color="text.disabled">
            {translate('collaborate.docs.trash.no_documents_in_trash')}
          </Typography>
        </Box>
      )}
      <Stack gap={1} p={1} overflow="auto">
        {trashDocs?.map((doc) => (
          <DocsTrashItem key={doc._id} doc={doc} />
        ))}
      </Stack>
    </CustomContainer>
  );
}

const CustomContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  height: '100%',
  minWidth: 350,
  maxHeight: 500,
  overflow: 'hidden',
}));
